import {
  NumericInput,
  NumericInputProps,
} from 'components/FormUtils/NumericInput/numeric-input'
import { FieldValues } from 'react-hook-form'
import { cn } from 'components/UI/cn'

export function FilterNumericInput<T extends FieldValues>(
  props: Omit<NumericInputProps<T>, 'getInputClassName'>
) {
  const getFilterClassName = (isFocused: boolean, hasValue: boolean) => {
    return cn({
      '!border !border-new-company-green-active': isFocused, // Active
      '!border !border-new-company-green-dark': !isFocused && hasValue, // Filled
      '!border !border-new-company-gray-inactive': !isFocused && !hasValue, // Empty
    })
  }

  return <NumericInput {...props} getInputClassName={getFilterClassName} />
}
